import React from "react";
import { ArrowRight } from "lucide-react";

const CVFormatSelector = ({ onSelect }) => {
  return (
    <div className="bg-white rounded-2xl p-10 shadow-lg border max-w-5xl mx-auto mt-8 animate-fadeIn">

      {/* Title */}
      <h2 className="text-3xl font-bold text-center mb-3 text-gray-800 tracking-tight">
        Choose Your CV Format
      </h2>

      <p className="text-center text-gray-600 mb-12 text-sm">
        Select the format that best highlights your strengths and experience
      </p>

      {/* Main Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-10">

        {/* Chronological CV */}
        <div className="bg-white rounded-2xl border shadow-md p-8 transition-all duration-300 hover:shadow-xl hover:-translate-y-1">
          
          {/* Circle Icon */}
          <div className="w-14 h-14 mx-auto mb-5 bg-blue-100 text-blue-600 flex items-center justify-center rounded-full text-2xl font-bold shadow-sm">
            📘
          </div>

          <h3 className="text-xl font-semibold text-gray-800 mb-2 text-center">
            Chronological CV
          </h3>

          <p className="text-gray-600 text-sm leading-relaxed text-center">
            Lists your work experience starting with the most recent.
          </p>

          <div className="bg-blue-50 p-5 rounded-xl mt-6 text-sm text-gray-700 shadow-inner">
            <p className="font-semibold mb-2 text-blue-700">Best for:</p>
            <ul className="list-disc ml-5 space-y-1">
              <li>Relevant work experience</li>
              <li>Steady career progression</li>
              <li>Clear skill development</li>
            </ul>
          </div>

          <button
            className="mt-7 w-full flex items-center justify-center gap-2 bg-blue-600 text-white py-3 rounded-xl font-medium hover:bg-blue-700 transition-all shadow-md"
            onClick={() => onSelect("chronological")}
          >
            Choose Chronological CV <ArrowRight className="w-4 h-4" />
          </button>
        </div>

        {/* Skill-Based CV */}
        <div className="bg-white rounded-2xl border shadow-md p-8 transition-all duration-300 hover:shadow-xl hover:-translate-y-1">
          
          {/* Circle Icon */}
          <div className="w-14 h-14 mx-auto mb-5 bg-green-100 text-green-600 flex items-center justify-center rounded-full text-2xl font-bold shadow-sm">
            📗
          </div>

          <h3 className="text-xl font-semibold text-gray-800 mb-2 text-center">
            Skill-Based CV
          </h3>

          <p className="text-gray-600 text-sm leading-relaxed text-center">
            Focuses on key skills rather than job titles and dates.
          </p>

          <div className="bg-green-50 p-5 rounded-xl mt-6 text-sm text-gray-700 shadow-inner">
            <p className="font-semibold mb-2 text-green-700">Best for:</p>
            <ul className="list-disc ml-5 space-y-1">
              <li>Limited work experience</li>
              <li>Career changers</li>
              <li>Strong skill portfolio</li>
            </ul>
          </div>

          <button
            className="mt-7 w-full flex items-center justify-center gap-2 bg-green-600 text-white py-3 rounded-xl font-medium hover:bg-green-700 transition-all shadow-md"
            onClick={() => onSelect("skill-based")}
          >
            Choose Skill-Based CV <ArrowRight className="w-4 h-4" />
          </button>
        </div>

      </div>
    </div>
  );
};

export default CVFormatSelector;
